import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { message } from 'antd';

import useDebouncedFunc from '../../../hooks/useDebounsedFunc';
import { useCompanyDocumentReminderSettingsQuery } from '../queries/useDocumentReminderSettings';
import { useMutation, useQueryClient } from 'react-query';
import { setCompanyDocumentReminderSetting } from '../requests/setCompanyDocumentReminderSetting';
import { queryKeys } from '../queries/queryKeys';
import { DocumentReminderCheckboxGroup } from './DocumentReminderCheckboxGroup';

export const CompanyDocumentReminderOverlay = ({ setVisible }) => {
  const companyId = useSelector(
    (store) => store.documentsStore.valueServiceCompany
  );

  const queryClient = useQueryClient();

  const documentReminderSettingsQuery = useCompanyDocumentReminderSettingsQuery(
    companyId,
    {
      enabled: !!companyId,
    }
  );

  const [checkedDocumentReminderOptions, setCheckedDocumentReminderOptions] =
    useState([]);

  useEffect(() => {
    if (!documentReminderSettingsQuery.data?.length) {
      return;
    }
    setCheckedDocumentReminderOptions(
      [...documentReminderSettingsQuery.data].sort()
    );
  }, [
    documentReminderSettingsQuery.data,
    documentReminderSettingsQuery.dataUpdatedAt,
  ]);

  const setCompanyDocumentReminderSettingMutation = useMutation(
    setCompanyDocumentReminderSetting,
    {
      onSuccess: () => {
        message.success('Настройки уведомлений успешно изменены');
        queryClient.invalidateQueries(
          queryKeys.companyDocumentReminderSettings(companyId)
        );
        setVisible(false);
      },
      onError: () => {
        message.error('Произошла ошибка при изменении настроек уведомлений');
      },
    }
  );

  const onCheckedDocumentReminderOptionsChanged = useDebouncedFunc(() => {
    if (
      !checkedDocumentReminderOptions.length ||
      JSON.stringify(documentReminderSettingsQuery.data.sort()) ===
        JSON.stringify(checkedDocumentReminderOptions.sort())
    ) {
      return;
    }
    setCompanyDocumentReminderSettingMutation.mutate({
      companyId,
      notificationTypeIds: checkedDocumentReminderOptions,
    });
  }, 1000);

  useEffect(onCheckedDocumentReminderOptionsChanged, [
    JSON.stringify(checkedDocumentReminderOptions),
  ]);

  return (
    <div>
      <div
        style={{
          padding: '8px',
          background: '#fff',
          borderRadius: '4px',
          boxShadow: '0 2px 8px rgb(0 0 0 / 15%)',
          overflow: 'hidden',
        }}
      >
        <div style={{ textAlign: 'center' }}>
          <div
            style={{
              display: 'inline-block',
              width: '320px',
            }}
          >
            Выберите уведомления модуля по умолчанию для всей компании,
            зависящие от даты назначения
          </div>
        </div>
        {companyId ? (
          <DocumentReminderCheckboxGroup
            loading={
              documentReminderSettingsQuery.isFetching ||
              setCompanyDocumentReminderSettingMutation.isLoading
            }
            value={checkedDocumentReminderOptions}
            onChange={setCheckedDocumentReminderOptions}
          />
        ) : (
          <div
            style={{
              width: '320px',
              color: 'red',
              textAlign: 'center',
            }}
          >
            Для настройки выберите управляющую компанию в фильтрах
          </div>
        )}
      </div>
    </div>
  );
};

CompanyDocumentReminderOverlay.propTypes = {
  setVisible: PropTypes.func.isRequired,
};
